/*eslint-disable*/
import React from 'react';
import {Select,Icon} from 'antd';
import {connect} from 'react-redux';
import AjaxAction from '../../actions/AjaxAction.js';
import actions from '../../actions/index.js';
import func from '../../util/func.js';
import {isWeb} from '../../util/index';
import AddConsumer from '../ConsumerList/AddConsumer.js';

class ConsumerSelect extends React.Component {
    static defaultProps = {

    };
    constructor(props){
        super();
        this.state = {
            list:(props.consumerObj && props.consumerObj.name) ? [props.consumerObj] : [],
            value:(props.consumerObj && props.consumerObj.name) ? props.consumerObj.name : props.value
        }
    }
    componentWillReceiveProps(nextProps){
        if(nextProps && nextProps.consumerObj){
            if(!this.state.value){
                this.setState({
                    list:(nextProps.consumerObj && nextProps.consumerObj.name) ? [nextProps.consumerObj] : [],
                    value:(nextProps.consumerObj && nextProps.consumerObj.name) ? nextProps.consumerObj.name : ''
                })
            }
        }
    }

    componentDidMount() {
        this.getList = func.debounce(this.getList, 800, false);
    }

    getList(value) {
        var now = Date.now();
        if(now > ((ConsumerSelect.cache.expires||0) + 100)) {
            let {dispatch} = this.props;
            dispatch(AjaxAction.consumers({
                key:JSON.stringify({'name[~]':value})
            })).then(data=>{
                this.setState({
                    list:data.data
                });

                ConsumerSelect.cache = {
                    expires:Date.now(),
                    list:data.data
                };
            });
        }else {
            this.setState({
                list:ConsumerSelect.cache.list
            });
        }
    }

    handleChange(value) {
        this.setState({ value });
        this.getList(value);
        // this.props.onChange(value);
        this.props.onSearch && this.props.onSearch(value);
        //var result = "";
        if(this.state.list && this.state.list.length) {
            var target = this.state.list.find(item=>{
                return item.name === value;
            });

            if(target) {
                this.props.onChange(target.id,target);
            }
        }
    }

    handleSelect(value) {
        this.setState({ value });

        if(this.state.list && this.state.list.length) {
            var target = this.state.list.find(item=>{
                return item.name === value;
            });

            if(target) {
                this.props.onChange(target.id,target);
            }
        }
    }

    renderOptions() {
        if(this.state.list.length) {
            return this.state.list.map((item, index)=>{
                return <Select.Option key={item.id} value={item.name} title={item.name}>{item.name}</Select.Option>;
            });
        }

        // return [<a >暂无此客户，点击此处添加客户</a>];
        return null;
    }

    addNewConsumer() {
        let {dispatch} = this.props;
        window.sessionStorage.setItem('temp', this.state.value);
        dispatch(actions.showAddConsumer(true));
    }

    afterAddConsumer(consumer) {
        this.getList(consumer.name);
        this.setState({
            value:consumer.name
        }, ()=>{
            this.props.onChange(consumer.id, consumer);
        });
    }

    render() {
        //console.log("rendered consumer select", this.state.value,this.props.consumerObj);
        let theValue = this.state.value ;//|| this.props.consumerObj.name;
        return <div>
            <Select
                mode="combobox"
                value={theValue}
                placeholder={"请输入客户名称"}
                style={{width:isWeb() ? '100%' : '195px', ...this.props.style}}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                disabled={this.props.disabled}
                onSelect={this.handleSelect.bind(this)}
                onChange={this.handleChange.bind(this)}>
                {this.renderOptions()}
            </Select>
            {theValue && this.state.list.length == 0 && this.props.showAdd ? (
                <a onClick={this.addNewConsumer.bind(this)}  style={{lineHeight:'32px',color:'rgb(245, 113, 95)'}}><Icon type="exclamation-circle-o" />客户不存在，点此添加新客户</a>
            ) : null}

            {this.props.showAdd ? <AddConsumer addCallback={this.afterAddConsumer.bind(this)}/> : null}
        </div>;
    }
}

ConsumerSelect.cache = {

};

export default connect((state) => ({
}))(ConsumerSelect);



// WEBPACK FOOTER //
// ./src/components/Select/ConsumerSelect.js